import WebGLPerspectiveCamera from './perspective'
import WebGLOrthographicCamera from './orthographic'

export {
  WebGLPerspectiveCamera,
  WebGLOrthographicCamera
}

export default WebGLPerspectiveCamera